import { ComplexBase } from '@syncfusion/ej2-react-base';
/**
 * `SpeedDialItemDirective` represent a item of the React SpeedDial.
 * It must be contained in a SpeedDial component(`SpeedDialComponent`).
 * ```tsx
 * <SpeedDialComponent>
 *   <SpeedDialItemsDirective>
 *    <SpeedDialItemDirective text='Cut'></SpeedDialItemDirective>
 *    <SpeedDialItemDirective text='Copy'></SpeedDialItemDirective>
 *   <SpeedDialItemsDirective>
 * </SpeedDialComponent>
 * ```
 */
export class SpeedDialItemDirective extends ComplexBase {
}
SpeedDialItemDirective.moduleName = 'speedDialItem';
export class SpeedDialItemsDirective extends ComplexBase {
}
SpeedDialItemsDirective.propertyName = 'items';
SpeedDialItemsDirective.moduleName = 'speedDialItems';
